import { FilterContext } from "@/_store/filters.module";
import { StoreModule } from "@/constants/store.ts";
import { createAllowBlockListStore } from "./msp-device-allow-block-list-factory.ts";

/**
 * Store for managing MSP Endpoint Security Allow/Block Lists.
 */
/**
 * Creates the store instance for the MSP Endpoint Security Allow/Block List.
 * It uses the factory with a specific configuration for this feature.
 */
export const useMspEndpointSecurityAllowBlockListStore = createAllowBlockListStore({
  id: StoreModule.MSP_ENDPOINT_SECURITY_ALLOW_BLOCK_LIST,
  filterContext: FilterContext.MSP_ENDPOINT_SECURITY_ALLOW_BLOCK_LIST_FILTERS,
  isEdr: false,
});
